import { h, Component } from 'preact'
import TransitionFade from '../TransitionFade'
import { Text } from 'preact-i18n'
import Success from './Success'
import {preventDefault} from '../../utils'

const mapValues = function(o, f) {
    var result = {}
    Object.keys(o).forEach(function(k) {
        result[k] = f.call(o, o[k], k, o)
    })
    return result
}

class ValidationError {
    constructor(name) {
        this.name = name
    }

    toString() {
        return this.name
    }
}

const Form = ({children, submit}) => 
    <form class="limba__form frame-type-form_formframework" onSubmit={submit}>
        {children}
        <button class="btn btn-primary mt-4" type="submit"><Text id="form.send" /></button>
    </form>

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default class ActiveForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: this.props.data || {},
            sending: false,
            error: {}
        }

        this.submit = e => {
            e.preventDefault()
            if (this.sending) return
            this.setState({data: this.getData()})
            let { additionalData = {} } = this.props
            let errors = this.getErrors()
            for (let key in errors)
                if (errors[key]) return
                 
            let submitData = {...this.getData(), ...additionalData}
            if (this.state.sending) return
    
            let { action } = this.props
            if (!action) return
            this.setState({sending: true})
            $.ajax(action, {method: 'POST', data: submitData})
                .done(() => {
                    this.setState({success: true})
                }).always(() => {
                    this.setState({sending: false})
                })
        }
    
        this.reset = (args) => {
            this.setState({
                success: false,
                data: {},
                error: {}
            })
            let { onReset = () => {}} = this.props
            onReset(args)
        }

        this.setValue = key => value => {
            let {fields = {}, onChange = () => {}} = this.props
            if (!fields[key]) return
            let nextData = { ...this.state.data, [key]: value }
            this.setState(() => ({
                data: nextData
            }))
            onChange(nextData)
        }
    
        this.getErrors = (lax) => {
            let {fields = {}} = this.props
            return mapValues(fields, (def, key) => {
                let value = this.state.data[key]
                if (lax && typeof value == 'undefined') return false
                let errorMsg = fields[key].type(value)
                if (errorMsg == value) return false
                return errorMsg
            })
        }
    
        this.getData = () => {
            let {fields = {}} = this.props
            return mapValues(fields, (def, key) =>
                (typeof this.state.data[key] == 'undefined') ?
                    def.default || '' :
                    this.state.data[key]
            )
        }
    }

    componentWillReceiveProps({data}) {
        if (data && (data != this.state.data)) {
            this.setState({data})
        }
    }

    getChildContext() {
        return {
            form: {
                data: this.getData(),
                error: this.getErrors(true),
                setValue: this.setValue
            }
        }
    }

    render (props, {success}) {
        return (
            <TransitionFade component={success ? Success : Form} componentName={success ? 'success' : 'form'} {...props} reset={this.reset} submit={this.submit} />
        )
    }
}

ActiveForm.types = {
    oneOf: (...options) => value => {
        if (value instanceof ValidationError) return value
        if (options.indexOf(value) == -1) return new ValidationError('WRONG_VALUE')
        return value
    },
    required: value => {
        if (value instanceof ValidationError) return value
        if (!value) {
            return new ValidationError('REQUIRED')
        }
        return value
    },
    mustAccept: value => {
        if (value instanceof ValidationError) return value
        if (!value) {
            return new ValidationError('MUST_ACCEPT')
        }
        return value
    },
    email: value => {
        if (value instanceof ValidationError) return value
        if (!value) return value
        if (emailRegex.test(value))
            return value
        return new ValidationError('INVALID_EMAIL')
    },
    optional: x => x
}


// WEBPACK FOOTER //
// ./js/components/Form/index.js